export const DEFAULT_FOLDER = "logos";
export const GENERATION_FOLDER = "generations";
export const DEFAULT_PLACEHOLDER = "/img/placeholder-brand.png";
export const DEFAULT_SIZE = 28;